<div class="relative pt-[100%]">
  <div class="absolute inset-0 size-full">
    <app-router-link
      [params]="params()"
      [route]="route()">
      <app-image-thumbnail
        [rounded]="false"
        size="full">
        <img
          [alt]="imageAlt()"
          [fill]="true"
          [ngSrc]="imageSrc()"
          class="object-contain" />
      </app-image-thumbnail>
    </app-router-link>
  </div>
</div>

<div class="flex flex-1 flex-col items-center py-3">
  <app-router-link
    [params]="params()"
    [route]="route()">
    <div class="py-3 text-center uppercase hover:underline">{{ name() }}</div>
  </app-router-link>

  <div class="mt-auto flex w-full flex-col items-center py-3">
    <app-public-cart-add-button
      [label]="buyLabel()"
      [sales]="sales()"
      maxWidth="16rem" />
  </div>
</div>
